<template>
  <div class="dropdown">
    <!-- <v-btn small class="ma-2" outlined color="white">
      <v-icon color="white">mdi-earth</v-icon>&nbsp; English
    </v-btn> -->
    <!-- <select v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    </select> -->
    <!-- <v-select
      v-model="$i18n.locale"
      :items="langs"
      small
      dark
      prepend-icon="mdi-earth"
    ></v-select> -->

    <v-btn color="white" text small>
      <v-icon>mdi-earth</v-icon>
      <span class="language">&nbsp; {{currentLang}}</span>
    </v-btn>
    <div class="dropdown-content">
      <a
        v-for="(lang, index) in languages"
        :key="`lang${index}`"
        @click="changeLanguage(lang)"
      >
        {{ lang.title }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      langs: ['English', 'German'],
      currentLang: 'English',
      languages: [
        {
          title: 'English',
          value: 'en'
        },
        {
          title: 'Deutsche',
          value: 'de'
        },
        {
          title: 'Gaeilge',
          value: 'ga'
        },
        {
          title: 'Magyar',
          value: 'hu'
        },
        {
          title: 'Íslensku',
          value: 'is'
        },
        {
          title: 'Español',
          value: 'es'
        },
        {
          title: 'Français',
          value: 'fr'
        },
        {
          title: 'русский',
          value: 'ru'
        }
      ]
    }
  },
  mounted() {
    if (localStorage.getItem('language')) {
      const startLang = JSON.parse(localStorage.getItem('language'))
      this.$i18n.locale = startLang.value
      this.currentLang = startLang.title
    } else {
      this.$i18n.locale = 'en'
      this.currentLang = 'en'
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang.value
      this.currentLang = lang.title
      localStorage.setItem('language', JSON.stringify(lang.value))
    }
  }
}
</script>

<style lang="scss">
.switcher {
  width: 200px;
  float: right;
}

.language {
  padding-left: 10px;
}

.dropdown {
  float: right;
  overflow: hidden;
}
.dropdown .dropbtn {
  font-size: 16px;
  border: none;
  outline: none;
  color: white;
  padding: 14px 16px;
  background-color: inherit;
  font-family: inherit;
  margin: 0;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown-content a {
  float: none;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}
.dropdown-content a:hover {
  background-color: #ddd;
}
.dropdown:hover .dropdown-content {
  display: block;
}
</style>
